import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario2 from "./Scenario2";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";
import GameManager from "../../cvp-webgames-core/GameManager";

export default class Scenario2Part1 extends BaseScenarioPart<CalmBaseScenario>{

	private partIndx = 0;


	chapterIds = {
		scenario2_1a_s1: 'CALM - Scenario 2 - 1A - Segment 1', //a.	Marco approaches CN, explains possible airborne precaution - to Respond UI
		scenario2_1a_s2: 'CALM - Scenario 2 - 1A - Segment 2', //a.	Marco leaves to tell the staff to don PPE, then returns with an update - to respond UI
		scenario2_1a_s3: 'CALM - Scenario 2 - 1A - Segment 3', //a.	Marco and CN check the policy on the computer - to Computer UI / Quiz
		scenario2_1a_s4: 'CALM - Scenario 2 - 1A - Segment 4', //a.	Marco & CN leave computer, Marco asks what else he should do - to Respond UI
		scenario2_1a_s5: 'CALM - Scenario 2 End - 1A - Segment 5', //a.	Marco leaves, Jamie approaches with question - to Respond UI
	}

	constructor(scenario: Scenario2, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario2/calm-scenario2-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part1.id;
	}

	public start() {
		const context = this;
		
		this.scenario.displayBeginScenarioUI('./assets/images/scenario2/begin-scenario-scenario2.jpg', 'calm-scenario2-begin-scenario', () => {
			this.scenario.playAmbientLoop(this.scenario.audioHall);
			context.segment1MarcoApproaches();
		});		
	}

	private segment1MarcoApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.scenario.updateObjective('Listen to Marco\'s update');
		this.playVideoChapter(this.chapterIds.scenario2_1a_s1, () => { //a.	Marco approaches CN, explains possible airborne precaution - to Respond UI
			context.scenario.updateObjective(' ');
			context.segment1Step2RespondToMarco();
		});
	}

	private segment1Step2RespondToMarco() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		var ppeResponseOption = "Make sure all staff interacting with him know to don PPE.";
		var policyResponseOption = "Let me look up our facility’s policies on airborne precaution patients, just to be sure we follow the proper procedures.";
		this.scenario.dialog(
			'CN-C09-L2-000a',
			[{
				text: policyResponseOption,
				isCorrect: false, // Response Rank is "Okay" 
				scoreType: ScoreType.Ok
			}, {
				text: 'Leave the patient where he is for now. Wait for a positive diagnosis before proceeding.',
				feedback: 'If a patient is being placed on airborne precaution, protocols need to be implemented and enforced immediately. This will ensure the patient is separated from others in order to maintain a safe environment and to protect other patients and staff. Leaving the patient in the room is not the best option in this scenario.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Response Rank is "Worst" 
			}, {
				text: ppeResponseOption,
				scoreType: ScoreType.Ok,
				isCorrect: false // Response Rank is "Okay" 
			}, {
				text: 'Get him to the negative pressure room. We need to prevent the unit from being contaminated.',
				scoreType: ScoreType.Best,
				isCorrect: true // Response Rank is "Best" 
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.gameManager.UiManager.hideAllUis([]);
				if (selectedOption.text.indexOf(ppeResponseOption) !== -1) {
					context.segment2aStep1PPEReplyDepart();
				}
				else if (selectedOption.text.indexOf(policyResponseOption) !== -1) {
					context.segment2cStep1policyReplyDepart();
					(context.scenario as Scenario2).policyResponse = true;
				}
				else {
					context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1NPressureMarcoDeparts(), context.partIndx); 
				}
			}
		);
		context.scenario.updateObjective("Select your response");
	}

	private segment2aStep1PPEReplyDepart() {

		this.scenario.gameManager.UiManager.hideAllUis([]); // if we need to show a ui for waiting for Marco, we should create an instance by ID then destroy by ID after so we dont destroy the respond UI
		var context = this;
		context.scenario.updateObjective("Wait for an update from Marco");
		this.playVideoChapter(this.chapterIds.scenario2_1a_s2, () => { //a.	Marco leaves to tell the staff to don PPE, then returns with an update - to respond UI
			this.scenario.gameManager.UiManager.showAllUis([]);
			context.scenario.updateObjective("");
		});
	}

	private segment2cStep1policyReplyDepart() {
		var context = this;
		context.scenario.updateObjective(' ');
		this.playVideoChapter(this.chapterIds.scenario2_1a_s3, () => { //a.	Marco and CN check the policy on the computer - to Computer UI / Quiz 
			context.scenario.updateObjective("Go to Nurse Station Computer with Marco");
			context.segment2cStep2ShowNurseStationComputer();
		});
	}

	private segment2cStep2ShowNurseStationComputer() { // This interaction is just a scrollable text field with text		
		var context = this;
		context.scenario.updateObjective("Review the S/KI TB Management Policy");
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					`
			<p class="regular-description-font" style="margin: 0">
				<span style="color: rgb(222, 225, 156)">INITIAL MANAGEMENT OF PATIENTS WITH S/KI TB</span> They have the experience to understand the delicacy 
				and urgency of a given situation and should be able to guide staff accordingly. <br /><br />

					<span style="color: rgb(222, 225, 156)">(1) Airborne precautions will be initiated promptly when a patient presents with symptoms of TB.</span> <br /><br />

						(a) The patient will be given a surgical-grade mask and will be instructed not to remove it.<br />


						(b) The patient will be placed in an isolation booth or negative airflow room as soon as possible. The patient may remove his/her mask while in the isolation booth or negative airflow room. If no isolation room/booth is available, the patient will remain masked.  <br />
					
					
						(c) A sign representing Airborne/Respiratory Isolation will be displayed outside the doorway to indicate isolation precautions are in effect. <br /><br />
					
						<span style="color: rgb(222, 225, 156)">(2) If a patient with S/KI TB must be transported outside the TB room/booth, the patient must wear a surgical mask. Staff transporting the patient do not need to wear respiratory protection outside the isolation room/booth during transportation.</span> <br /><br />

						<span style="color: rgb(222, 225, 156)">(3) Staff must wear NIOSH approved respiratory protection (N95 or better) at all times within the negative pressure isolation room/booth.</span> <br /><br />

						<span style="color: rgb(222, 225, 156)">(4) Cough-inducing procedures such as sputum induction of acid-fast bacillus (AFB), or bronchoscopy or endotracheal intubation must be performed in a negative pressure isolation room/booth. Staff collecting these specimens must wear NIOSH approved respiratory protection (N95 or better) during the procedure.</span> <br /><br />
			</p>
			`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment2cStep3PolicyQuiz();
			}
		})
	}

	private segment2cStep3PolicyQuiz() {
		var context = this;
		context.scenario.updateObjective('Select your response');
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'While transporting an S/KI TB patient to the negative pressure room, who needs to wear a face mask according to this unit’s policy?',
			options: [
				{
					text: 'Only the staff moving the patient need an N95 mask or PAPR.',
					isCorrect: false,
					feedback: 'Staff do not need any mask during transport according to this unit’s policy.'
				},
				{
					text: 'Both staff and patient need a surgical mask.',
					isCorrect: false,
					feedback: 'Only one of these individuals, not both staff and patient, are required to wear a mask during transport. '
				},
				{
					text: 'Only the patient needs a surgical mask.',
					isCorrect: true,
					feedback: 'For this unit’s policy, only the patient is required to wear a surgical mask during transport so as not to alarm others and given the type of transmission for TB. '
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx,[constants.uiTags.youRespond]) 
			},
			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => { 
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment2dStep1PolicyReplyReturn();
			},

		});		
	}

	private segment2dStep1PolicyReplyReturn() {
		var context = this;
		context.scenario.updateObjective('');
		this.playVideoChapter(this.chapterIds.scenario2_1a_s4, () => { //a.	Marco & CN leave computer, Marco asks what else he should do - to Respond UI
			context.scenario.updateObjective("Select your response");
			this.scenario.gameManager.UiManager.showAllUis([]);
		});
	}

	private segment3Step1NPressureMarcoDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective(' ');
		this.playVideoChapter(this.chapterIds.scenario2_1a_s5, () => {
			context.scenario.updateObjective('');
			context.partEnd();  // This is going to test the transition functionality between Scenario Parts, as the individual parts no longer always end at the computer and will segway into each other as the story being treated is changed.
		});
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.onDone();

	}
}
